var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.cmpColor)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.valor)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }